import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@client/App";
import "@client/styles/globals.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("#root is missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
